export default {
    LAO_GET_ALL_FAVS_SUCCESS: "LAO_GET_ALL_FAVS_SUCCESS",
    LAO_GET_ALL_FAVS_FAILED: "LAO_GET_ALL_FAVS_FAILED",
    LAO_FAV_BU_SUCCESS: "LAO_FAV_BU_SUCCESS",
    LAO_FAV_BU_FAILED: "LAO_FAV_BU_FAILED",
    LAO_FAV_SITE_SUCCESS: "LAO_FAV_SITE_SUCCESS",
    LAO_FAV_SITE_FAILED: "LAO_FAV_SITE_FAILED",
    LAO_FAVS_LOADING: "LAO_FAVS_LOADING",
}